import { required } from 'vuelidate/lib/validators'
import { mapGetters, mapActions } from 'vuex'
import { generateKey, generateTotpUri } from 'authenticator'
import QrCode from 'vue-qrcode-component'
import { ErrorCodes, Constants } from 'src/constants'

export default {
  components: {
    QrCode
  },
  computed: {
    ...mapGetters({
      user: 'passport/user',
      verificator: 'passport/defaultVerificator'
    }),
    authenticatorUri () {
      if (!this.form.secret) {
        return null
      }

      const credential = this.user.credentials[0]
      const type = credential.type
      let name

      if (type === 'EMAIL' || type === 'LOGIN') {
        name = credential.login
      } else if (type === 'GOOGLE') {
        name = `Google-${credential.socialId}`
      } else if (type === 'FACEBOOK') {
        name = `Facebook-${credential.socialId}`
      } else if (type === 'TELEGRAM') {
        name = `Telegram-${credential.socialId}`
      }

      const uri = generateTotpUri(this.form.secret, name, 'Chrono.tech')
      return uri
    },
    formattedSecret: {
      get () {
        return this.form.secret
          ? this.form.secret.replace(/\W/g, '').toUpperCase()
          : null
      },
      set (value) {
        this.form.secret = value.toLowerCase().match(/.{1,4}/g).join(' ');
      }
    },
  },
  data () {
    return {
      form: {
        secret: generateKey(),
        code: ''
      },
      error: null,
      isErrorVisible: false,
      isBusy: false,
      isPasswordVisible: false,
      isResendCode: false,
      twofaConfirmationCodeLength: Constants.confirmation.twofaConfirmationCodeLength
    }
  },
  validations: {
    form: {
      secret: {
        required
      },
      code: {
        required,
        isComplex () {
          return this.form.code.length === this.twofaConfirmationCodeLength
        }
      }
    }
  },
  watch: {
    'form.code': {
      async handler () {
        if (!this.isResendCode && this.form.code.length === this.twofaConfirmationCodeLength) {
          await this.handleSubmit()
        }
      }
    }
  },
  methods: {
    ...mapActions({
      enable2FA: 'passport/enable2FA'
    }),
    async handleRefreshSecret () {
      this.form.secret = generateKey()
    },
    async handleSubmit () {
      this.isBusy = true
      this.isErrorVisible = false
      this.error = null
      setImmediate(async () => {
        try {
          await this.enable2FA({
            ...this.form
          })
          // setImmediate(() => {
          //   this.$router.push('/security/grant')
          // })
        } catch (e) {
          if (e.response.data.error.code === ErrorCodes.INTERNAL_ERROR) {
            this.error = 'Invalid code'
          } else {
            this.error = 'Unknown error'
          }
          this.isErrorVisible = true
        } finally {
          this.isBusy = false
          this.isResendCode = true
        }
      })
    }
  }
}
